/**
 * Sandeep Sirohi: Inactivity service, logged out the user after  specific inactivity time period.
 * Date: 04/11/2024
 */

import React, { useEffect, useState } from 'react';
import HttpRequest from '../service/httpService'
import { toast } from 'react-toastify';
import { getSettingValue } from '../service/userService';
import { msalInstance } from '..';
var inactivityTimerId: any = null;

//Logout logic
const logout = () => {
    toast.info("You are being loggout out from the system.")
    msalInstance.logout();
    //console.log('logged  out' + new Date());
};

//Sandeep: Create timer based on timeout value from system settings.
const resetTimer = () => {
    let timeout = getSettingValue("SystemTimeout")
    //console.log('activity');
    if (timeout && Number(timeout) > 0) {
        clearTimer();
        let timeoutId = setTimeout(logout, Number(timeout) * 60 * 1000);
        inactivityTimerId = timeoutId;
    }
};

//Clears timer
const clearTimer = () => {
    if (inactivityTimerId != null) {
        clearTimeout(inactivityTimerId);
    }
};
//Register handlers
export const registerInactivityService = () => {
    // Add event listeners for user activity
    resetTimer();
    const events: Array<keyof WindowEventMap> = ['mousemove', 'keydown', 'scroll', 'touchstart'];
    events.forEach(event => window.addEventListener(event, resetTimer));
}

//Unregister handlers
export const unregisterInactivityService = () => {
    // Clean up event listeners and timeout
    const events: Array<keyof WindowEventMap> = ['mousemove', 'keydown', 'scroll', 'touchstart'];
    events.forEach(event => window.removeEventListener(event, resetTimer));
    clearTimer();
}
